// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Component Imports
// JS Imports
// Asset Imports

export default function MultiEntityDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_view != 'External' &&
      state.user_role != 'Partner' &&
      state.user_role != 'Reseller'
   )
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list['relatedEntity']['DiscountDescription']
                  }
                  discountName={
                     state.discount_list['relatedEntity']['DiscountName']
                  }
                  hoverTitle={getString(
                     'product.MultiEntityDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountMultiEntity}
                  onChange={() => state.setDiscountMultiEntity((prev) => !prev)}
               ></input>
            </div>
            <div className='col'>
               {state.discount_list['relatedEntity']['DiscountAmount']}%
            </div>
         </div>
      )
}
